/**
 * Shared audio/voice types — extracted to break circular dependency
 * between stories and audio-stories contexts.
 *
 * Both contexts import these types from here instead of from each other.
 */

// ─── Language ────────────────────────────────────────────────────────────────
// Originally in stories/types/enums.ts, used by both contexts.

export const Language = {
  Cs: 'cs',
  De: 'de',
  En: 'en',
  Fr: 'fr',
  Ru: 'ru',
  Uk: 'uk',
} as const;

// eslint-disable-next-line no-redeclare
export type Language = (typeof Language)[keyof typeof Language];

// ─── Audio Enums ─────────────────────────────────────────────────────────────
// Originally in audio-stories/types/enums.ts, used by stories/types/story.ts.

export enum AudioSource {
  Tts = 'tts',
  UserRecording = 'user_recording',
}

export enum AudioFragmentStatus {
  Completed = 'completed',
  NoAudio = 'no_audio',
  Failed = 'failed',
}

// ─── TTS Config ──────────────────────────────────────────────────────────────
// Originally in audio-stories/types/voiceSettings.ts, used by stories/types/pipeline.ts.

/** A TTS model id as the worker manifest names it (never enumerated in the portal). */
export type TTSModel = string;

export interface TTSConfig {
  voiceId: string;
  voiceName?: string;
  model?: TTSModel;
  stability?: number;
  similarityBoost?: number;
  style?: number;
  useSpeakerBoost?: boolean;
}

// ─── Voice Resolution ────────────────────────────────────────────────────────
// Originally in stories/types/index.ts, used by audio-stories/services/AudioGenerator.ts.
